<div class="wrapper">
  <div class="container-fluid">

    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <!-- <li class="breadcrumb-item"><a href="javascript: void(0);">Home</a></li> -->
              <li class="breadcrumb-item active">Parcel tracking </li>
            </ol>
          </div>
          <h4 class="page-title">Parcel tracking</h4>
        </div>
      </div>
    </div>


    <div class="row">
      <div class="col-12">

        <div class="card-box">
          <h4 class="header-title">Parcel tracking</h4>
          <p class="sub-header">
            Terminal tracking
          </p>

          <div class="row">
            <div class="form-group row" *ngIf="success" style="width:100%;">
              <div class="col-md-12 form-horizontal px-6" style="width:100%;">
                <ngb-alert type="info" [dismissible]="false" style="width:100%;">
                  <strong></strong> {{message}}
                </ngb-alert>
              </div>
            </div>

            <div class="form-group" *ngIf="raiseDanger" style="width:100%;">
              <div class="col-md-12 form-horizontal px-6" style="width:100%;">
                <ngb-alert type="danger" [dismissible]="false" style="width:100%;">
                  <strong>Error!</strong> {{danger}}
                </ngb-alert>
              </div>
            </div>

          </div>

          <div class="row form-horizontal">
            <div class="col-md-6 form-horizontal px-3">


              <div class="form-group row">
                <label class="col-3 col-form-label">WayBill number </label>
                <div class="col-6">
                  <input class="form-control" type="text" name="wayBill" [(ngModel)]="wayBill" [ngModelOptions]="{standalone: true}" required>
                </div>
                <div class="col-3">
                  <button type="submit" class="btn btn-info waves-effect waves-light float-right" (click)="submit()">
                    Submit <i class="mdi mdi-pencil-box-outline"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="col-md-12 form-horizontal px-3">

              <div class="form-group row" style="width:100%;">
                <div class="col-md-12 form-horizontal px-6" style="width:100%;">

                  <table datatable [dtTrigger]="dtTrigger" class="table table-striped mb-0" style="width: 100%">
                    <thead>
                      <tr>
                        <th class="col-2">Date</th>
                        <th class="col-2">Tracking code</th>
                        <th class="col-2">Description</th>
                        <th class="col-2">Location</th>
                        <th class="col-2">Country</th>
                        <th class="col-2">Customer description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let transaction of transactions">
                        <td>{{ transaction.action_date}}</td>
                        <td>{{ transaction.tracking_code}}</td>
                        <td>{{ transaction.description}}</td>
                        <td>{{ transaction.location}}</td>
                        <td>{{ transaction.update_country}}</td>
                        <td>{{ transaction.customer_description}}</td>
                        <td>
                      </tr>

                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end page title -->
    </div>
  </div>
